import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import cx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { IconDownloadOutlined } from '@repo/monochrome-icons';
import { useSegment } from '@repo/poly-hooks/segment';
import styles from './actions.module.css';

interface CreditNotesActionsProps extends ComponentPropsWithoutRef<'div'> {
  pdfUrl: string;
}

export function CreditNotesActions({
  pdfUrl,
  className,
  ...props
}: CreditNotesActionsProps): ReactNode {
  const segment = useSegment();

  const handleClick = (): void => {
    segment.track('public-page-credit-note_download_clicked');
  };

  return (
    <div className={cx(styles.actions, className)} {...props}>
      <a
        className="btn"
        data-test-credit-note-actions-download
        href={pdfUrl}
        onClick={handleClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        <IconDownloadOutlined className="mr-8" />
        <FormattedMessage id="credit-note.preview.cta.download" />
      </a>
    </div>
  );
}
